import { render, staticRenderFns } from "./v-popup.vue?vue&type=template&id=6361a827&scoped=true"
import script from "./v-popup.vue?vue&type=script&lang=js"
export * from "./v-popup.vue?vue&type=script&lang=js"
import style0 from "./v-popup.vue?vue&type=style&index=0&id=6361a827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../com-tool/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361a827",
  null
  
)

export default component.exports